import { Component, Input, OnInit } from '@angular/core';
import { TournamentDetailsService } from '../../tournaments/tournament-details/tournament-details.service';
import { Court } from '../../_shared/models/csTypes/court';
import { Venue } from '../../_shared/models/csTypes/venue';
import { Match } from '../../_shared/models/match.model';
import { Tournament } from '../../_shared/models/tournament.model';
import { ScoreboardService } from '../scoreboard.service';

@Component({
  standalone: false,
    selector: 'app-tournament-top-row',
    templateUrl: './tournament-top-row.component.html',
    styleUrls: ['./tournament-top-row.component.scss'],
})
export class TournamentTopRowComponent implements OnInit {
    @Input() match: Match;
    tournament: Tournament;

    constructor(
        public scoreboardService: ScoreboardService,
        private tournamentDetailsService: TournamentDetailsService
    ) { }

    async ngOnInit() {
        this.tournament = await this.tournamentDetailsService.getTournamentInfo(this.match.tournament);
    }

    getTime(scheduledTime: string) {
        return scheduledTime?.includes('T')
            ? scheduledTime
            : `1970-01-01T${scheduledTime}`;
    }

    getCourtName() {
        const index = this.match.extensions?.findIndex(ext => ext.name === 'court');

        if (index > -1 && this.match.extensions[index].value.courtName.length > 1) {
            return this.match.extensions[index].value.courtName;
        }

        if (this.tournament.partner === 'USTA' || this.tournament.partner === 'ITA' || this.tournament.partner === 'USHS') {

            const courtVenue: Venue = this.tournament?.venues?.find(venue => venue?.venueId?.toUpperCase() === this.match.schedule?.venueId?.toUpperCase());
            const court: Court = courtVenue?.courts?.find(c => c.courtId?.toUpperCase() === this.match.schedule?.courtId?.toUpperCase());

            let location = '';
            if (court?.courtName) {
                location += court.courtName;
            }

            if (courtVenue?.venueAbbreviation) {
                location += ` at ${courtVenue?.venueAbbreviation}`;
            }

            return location;

        } else if (this.tournament.partner === 'tmx') {
            const splitCourtId = this.match.schedule.courtId?.split('|');
            if (splitCourtId) {
                const courtVenue: Venue = this.tournament?.venues?.find(venue => venue.venueId === splitCourtId[0]);

                if (courtVenue) return courtVenue?.courts[splitCourtId[1]].courtName;
            }
        }

        return null;
    }

}
